var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgI1LiftTruck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.92 45c0 2.66-9.06 4-11.31 4H49V12h4v33h18.92zM68 29H56v12h12V29zm-22.07 6.88L46 55h-3.42a7 7 0 00-13.69-.66c-.06.23-.09.44-.13.66h-7.55a6 6 0 00-10.57-1.36A5.77 5.77 0 0010 55H8l-4-5V39h24V24h11.14l.59.5c5 4.64 6 9.04 6.2 11.38zm-3.93 0c0-1.69-.61-4.4-4-7.88h-6v6.75L36.1 39H42v-3.12zM35.67 52a4 4 0 00-3.85 3 .14.14 0 000 .07c-.087.326-.13.662-.13 1-.01.133-.01.267 0 .4l.1.6a4 4 0 007.86-1 4.342 4.342 0 00-.15-1A4 4 0 0035.67 52zm-20.1 2a3 3 0 00-1.78.6 2.41 2.41 0 00-.41.37 2.89 2.89 0 00-.71 1.31 2.844 2.844 0 00-.1.72v.3l.08.45a3 3 0 005.79 0c.064-.245.098-.497.1-.75a3 3 0 00-3-3h.03z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/I1_Lift_truck.50605a63.svg";
export { SvgI1LiftTruck as ReactComponent };